module.exports = __webpack_public_path__ + "static/bahamut-teach-students-1d504a4af025436541b0511cb6d25f6a.jpg";